<template>
    <v-dialog
      v-model="isMachineQR"
      persistent
    >
      <v-card>
         <v-card-title>
           機器のQRコードを印刷
        </v-card-title>

         <v-card-text>
          機器専用のQRコードを印刷します。<br>
          下記の機器リストより、印刷する機器の<v-chip color="amber darken-1" small><v-icon small>mdi-qrcode</v-icon>QRコードを印刷する</v-chip>ボタンをクリックすると、印刷ページへ遷移します。
         </v-card-text>

        <div class="my-3">
          <v-card outlined max-width="80%" class="mx-auto" color="amber lighten-5">
            <v-card-title>
              <v-icon>mdi-qrcode</v-icon>
              <span class="title font-weight-light">マイ機器QRコードとは？</span>          
            </v-card-title>
            <v-card-text class="body-2">
              機器を識別するために、機器専用に用意しているQRコードです。<br>
              このQRコードをスマートフォンやタブレットから読み取ると、「分析サンプルの採取登録」画面にダイレクトにアクセスすることができます。<br>
              機器からサンプルを採取したその場ですぐに登録することができるので、採油作業の効率アップになり、おすすめしています。
            </v-card-text>
          </v-card>
        </div>

        <div class="pa-4">
        <v-row>
          <v-col cols="12">
            <div class="px-3">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="マイ機器を検索"
              filled
            ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="machines"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :search="search"
              :sort-by="['Name']"
              :sort-desc="[false]"
              :loading="loading"
              class="elevation-1"
              loading-text="読込中"
              no-data-text="データがありません。"                    
              no-results-text="検索条件に該当するデータがありません。"                  
              hide-default-footer
              @page-count="pageCount = $event"
              id="row-pointer"
            >
              <!-- @click:row="(data) => { $router.push(`/mymachine?id=${data.id}`) }" -->
              <template v-slot:[`item.id`]="{ item }">
                <v-tooltip left color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" rounded x-small elevation="1" color="amber" :to="{ path: 'mymachineqrcode/', query: { id: item.id, name: item.Name, machineid:item.CustomerMachineID, PurchasedDate:item.PurchasedDate  }}" class="mx-2 caption" id="sample_btn">
                      <v-icon 
                        small 
                        >mdi-qrcode</v-icon>
                        QRコードを印刷
                    </v-btn>
                  </template>
                  <span>クリックすると、マイ機器QRコード印刷の画面へ遷移します</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" md='10' sm='12'>
            <v-pagination
              v-model="page"
              :total-visible="totalVisible"
              :length="pageCount"
              color="amber black--text"
              light 
              circle
            >
            </v-pagination>
          </v-col>
          <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
            <v-select
              :value="itemsPerPage"
              :items = "itemsPerPageList"
              label="1ページの行数"
              @input="itemsPerPage = $event"
            ></v-select>
          </v-col>

          <!-- <v-col cols="2" md='2' sm='4'>
            <v-text-field
              :value="itemsPerPage"
              label="1ページの行数"
              @input="itemsPerPage = $event"
            ></v-text-field>
          </v-col> -->
        </v-row>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            outlined
            rounded
            @click="isMachineQR=false"
            class="mb-5 mr-5"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>
<script>
import { machinesEvent } from "../utils/eventbus.js"

export default {
    data: () => ({
      isMachineQR: false,
      search: '',
      page: 1,
      pageCount: 0,
      totalVisible: 7,
      itemsPerPage: 5,
      itemsPerPageList: [ 5,10,30 ],
      loading: false,      
      machines: [],
      headers: [
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
        },
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text"

        },
        {
        text: 'QR印刷',
        value: 'id',
        class: "grey darken-2 white--text"
        },

      ],

    }),
    methods: {
      machineDataGet: async function (machines) {
        // console.log('machines', machines)
      this.machines = machines
      },
    open() {
      // console.log('from QRmodal')
      this.isMachineQR = true
    }
    },
    mounted: async function () {
      machinesEvent.$on('machinesData', this.machineDataGet)      
    },
}
</script>

